import { useQuery } from '@tanstack/react-query';

import { backendApis } from '@/backendApis';

import type { McpCallFilters } from './mcp-info.types';

const REFETCH_INTERVAL_MS = 30_000;

/** Filters carry a window in hours; the API takes an absolute lower bound. */
function sinceIso(sinceHours: number): string {
  return new Date(Date.now() - sinceHours * 60 * 60 * 1000).toISOString();
}

export function useMcpCallsQuery(filters: McpCallFilters) {
  return useQuery({
    queryKey: ['mcp-info', 'calls', filters],
    queryFn: ({ signal }) =>
      backendApis.mcpInfo.listCalls(
        {
          client_name: filters.clientName ?? undefined,
          tool_name: filters.toolName ?? undefined,
          since: sinceIso(filters.sinceHours),
        },
        signal
      ),
    refetchInterval: REFETCH_INTERVAL_MS,
  });
}

export function useMcpUsageSummaryQuery(sinceHours: number) {
  return useQuery({
    queryKey: ['mcp-info', 'summary', sinceHours],
    queryFn: ({ signal }) =>
      backendApis.mcpInfo.getSummary(sinceIso(sinceHours), signal),
    refetchInterval: REFETCH_INTERVAL_MS,
  });
}

export function useMcpCallQuery(callId: string | null) {
  return useQuery({
    queryKey: ['mcp-info', 'call', callId],
    queryFn: ({ signal }) => backendApis.mcpInfo.getCall(callId ?? '', signal),
    enabled: !!callId,
  });
}
